import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MegaphoneIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M11,6v6a1.85,1.85,0,0,1-1.67,2H7.67A1.67,1.67,0,0,1,6.19,13,2.4,2.4,0,0,1,6,12V6a2.4,2.4,0,0,1,.19-1A1.67,1.67,0,0,1,7.67,4H9.33A1.85,1.85,0,0,1,11,6Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M4,6H5A0,0,0,0,1,5,6v6a0,0,0,0,1,0,0H4a1,1,0,0,1-1-1V7A1,1,0,0,1,4,6Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M7,15h3a0,0,0,0,1,0,0v5a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V15a0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M21,3V15a17.88,17.88,0,0,0-10-3V6A17.88,17.88,0,0,0,21,3Z"
  })]
}), 'MegaphoneIcon');